<template>
	<div class="c-debug">
		<div class="c-debug__container">
			<div
				class="c-debug__item"
				v-for="(action, i) in updateQueue"
				:key="action._id"
			>
				<div class="c-debug__label">
					{{ action.name }}
				</div>
				<div class="c-debug__counter">
					<span>
						{{ i }}
					</span>
				</div>
			</div>
		</div>
		<div class="c-debug__container">
			<h5>{{ $store.getters['block/blocks'].length }}</h5>
			<div class="c-debug__group" v-for="(group, i) in undoQueue" :key="i">
				<div
					class="c-debug__item"
					v-for="(action, j) in group"
					:key="action._id"
				>
					<div class="c-debug__label">
						{{ action.name }}
					</div>
					<div class="c-debug__counter">
						<span>
							{{ i }}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		updateQueue: function () {
			return this.$store.getters['transaction/updateQueue'];
		},
		undoQueue: function () {
			return this.$store.getters['undo/undoQueue'];
		},
	},
};
</script>

<style lang="scss">
.c-debug {
	position: fixed;
	bottom: 0;
	left: 0;
	max-height: 600px;
	overflow-y: auto;
	padding: var(--spacer-sm) var(--margin-lg);
	background-color: #111;
	display: flex;
	justify-content: end;
	align-items: center;

	@include scrollBars();

	&__item {
		display: flex;
		justify-content: space-between;
	}

	&__group {
		margin: var(--margin) var(--margin-lg);
		padding: var(--margin);
		border-radius: 15px;
		background-color: rgba(255, 255, 255, 0.075);
	}

	&__label {
		margin: var(--margin) 0;
		padding: var(--margin) var(--margin-lg);
		background-color: royalblue;
		border-radius: 10px;
		color: #fff;
		font-weight: 500;
		font-size: var(--font-size-sm);
	}

	&__counter {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: var(--spacer-sm);
		width: var(--spacer);
		height: var(--spacer);
		border-radius: var(--spacer-lg);
		background-color: #444;
		font-weight: 700;
		font-size: var(--font-size-sm);
	}
}
</style>